import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Modal} from 'react-bootstrap';

import 'react-date-picker/index.css';
import {DateField, DatePicker} from 'react-date-picker';

import * as Actions from 'actions';

class EditTask extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			task : {
				text : null,
				due_date : null
			}
		}
		
		this.handleDateChange = this.handleDateChange.bind(this);
		this.handleTextChange = this.handleTextChange.bind(this);
		this.save = this.save.bind(this);
	}

	handleDateChange(selected_date) {
		let temp_task = Object.assign({}, this.state.task)
		temp_task.due_date = selected_date
		this.setState({task : temp_task})
	}

	handleTextChange(event) {
		let temp_task = Object.assign({}, this.state.task)
		temp_task.text = event.target.value;
		this.setState({task : temp_task})
	}

	save() {
		let task = Object.assign({}, this.state.task, {_id : this.props.task._id})
		this.props.sendSocketEmit(task, 'edit-task');
		this.props.hide();
		this.setState({task : {text : null, due_date : null}})
	}

	render() {
      return (
      	<Modal show={this.props.show} onHide={this.props.hide} bsSize='sm'>
      		<div className='edit-task-container'>
	      		<div className='panel panel-primary mb-none'>
	      			<div className='panel-heading'>
	      				<h3 className='panel-title'>Edit Task</h3>
	      			</div>
	      			<div className='panel-body'>
	      				<div className='col-md-12'>
		      				<div className='row mb-lg'>
			      				<div className='form-group'>
			      					<h4>Task Details</h4>
			      					<textarea 
			      						className='form-control edit-task-text-area' 
			      						onChange={this.handleTextChange}
			      						value={this.state.task.text === null ? this.props.task.text : this.state.task.text}/>
			      				</div>
		      				</div>
		      				<div className='row'>
		      					<h4>Select Date</h4>
		      					<DateField
											dateFormat='MM/DD/YYYY'
											defaultValue={new Date(this.state.task.due_date || this.props.task.due_date)}
											>
											<DatePicker 
												onChange={this.handleDateChange}
												isDatePicker={true}
											/>
										</DateField>
		      				</div>
	      				</div>
	      			</div>
	      			<div className='panel-footer'>
	      				<div className='row'>
									<div>
	  								<div className='col-md-12 mb-sm'>
	        						<div 
	        							onClick={this.props.hide} 
	        							className='btn btn-block btn-default'>Cancel
	        						</div>
	        					</div>
	        					<div className='col-md-12'>
	        						<div 
	        							onClick={this.save} 
	        							className='btn btn-block btn-primary'>Save
	        						</div>
	        					</div>
	      					</div>
	      				</div>
	      			</div>
	      		</div>
      		</div>
      	</Modal>
      );
    }
}

export default connect(null, Actions)(EditTask)


// WEBPACK FOOTER //
// ./src/browser/components/tasks/editTask.js